import { forwardRef, Ref, useImperativeHandle, useState } from 'react';
import useIndicatorDotSizes from './use-dots-type';
import cls from 'classnames';
import _range from 'lodash/range';

import './style.scss';

export interface DotIndicatorProps {
  className?: string;
  count: number;
  onChange: (target: number) => void;
}

export interface DotIndicatorRef {
  changeTo: (target: number) => void;
}

export const DotIndicator = forwardRef((props: DotIndicatorProps, ref: Ref<DotIndicatorRef>) => {
  const { className, count, onChange } = props;
  const [currentIndex, setCurrentIndex] = useState(0);
  const indicatorDotSizes = useIndicatorDotSizes(count, currentIndex);

  const handleDotClick =
    (index: number): (() => void) =>
    () => {
      setCurrentIndex(index);
      onChange(index);
    };

  useImperativeHandle(ref, () => {
    return {
      changeTo: setCurrentIndex,
    };
  });

  return (
    <div className={cls('dot-indicator', className)}>
      {_range(count).map((index) => (
        <div
          key={index}
          className={cls('dot-indicator-dot', indicatorDotSizes[index], {
            selected: index === currentIndex,
          })}
          onClick={handleDotClick(index)}
        />
      ))}
    </div>
  );
});
